import HoverEvent from './HoverEvent'

export default HoverEvent
